import { createPortalHeader } from "../../admin-shared/PortalHeader";
import { useUser } from "../context/UserContext";
import { API_BASE, clearPortalStorage, PORTAL_ID } from "../utils/api";
import { loginPathForRole } from "../utils/loginPaths";
import { resolveMediaUrl, resolveStoredOrgLogo } from "../utils/mediaUrl";
import {
  applyThemeToDocument,
  getStoredTheme,
  THEME_STORAGE_KEY,
} from "../utils/theme";
import { fetchCheckinQueue } from "../utils/checkinQueueApi";
import nyafaz from "../assets/nyafazlogo.png";

const Header = createPortalHeader({
  portalId: PORTAL_ID,
  portalBasePath: "/naturals/executive",
  useUser,
  API_BASE,
  clearPortalStorage,
  loginPathForRole,
  resolveMediaUrl,
  resolveStoredOrgLogo,
  logoFallback: nyafaz,
  applyThemeToDocument,
  getStoredTheme,
  THEME_STORAGE_KEY,
  fetchCheckinQueue,
});

export default Header;
